import React from 'react';
import { useIntl } from 'react-intl';

import { renderWithBreaks } from '@utils/translations';

const TermsOfServiceTab = () => {
  const intl = useIntl();

  return (
    <div>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service introduction' }))}
      <h5>
        {intl.formatMessage({ id: 'Please read this document carefully. It contains important information about your rights and obligations. In particular, it contains:' })}
      </h5>
      <ul>
        <li>{intl.formatMessage({ id: 'a disclaimer of warranty and a limitation of liability (in clause 21), which together limit our responsibilities and liability to users and accommodation providers;' })}</li>
        <li>{intl.formatMessage({ id: 'a reimbursement clause under which users (in clause 12.9) agree to reimburse Uniplaces in certain circumstances;' })}</li>
        <li>{intl.formatMessage({ id: 'an indemnity clause (in clause 22) under which accommodation providers, which are businesses, will indemnify Uniplaces in certain circumstance.' })}</li>
      </ul>
      <h5>
        {intl.formatMessage({ id: 'You are advised to review these provisions carefully before proceeding.' })}
      </h5>
      <h5>
        {intl.formatMessage({ id: 'If there is an inconsistency between any of the provisions of this English language version and a translated version, the provisions of this English language version shall prevail. Any translated versions of these Terms of Service and the Terms of Use shall be for convenience only.' })}
      </h5>
      <h3>{intl.formatMessage({ id: '1. About these Terms of Service' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 1' }))}
      <h3>{intl.formatMessage({ id: '2. Acceptance of Terms of Service' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 2' }))}
      <h3>{intl.formatMessage({ id: '3. What is the Website?' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 3' }))}
      <h3>{intl.formatMessage({ id: '4. Information Displayed on the Website' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 4' }))}
      <h3>{intl.formatMessage({ id: '5. Booking Accommodation' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 5' }))}
      <h3>{intl.formatMessage({ id: '6. Confirmation of a Booking' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 6' }))}
      <h3>
        {intl.formatMessage({ id: '7. Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013' })}
      </h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 7' }))}
      <h3>{intl.formatMessage({ id: '8. The 1st Rental Payment' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 8' }))}
      <h3>{intl.formatMessage({ id: '9. Tenancy Agreement' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 9' }))}
      <h3>{intl.formatMessage({ id: '10. Move in Date' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 10' }))}
      <h3>{intl.formatMessage({ id: '11. Cancellations' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 11' }))}
      <h3>{intl.formatMessage({ id: '12. Uniplaces Rent Guarantee' })}</h3>
      <p>
        {intl.formatMessage({ id: '12.1 Uniplaces Rent Guarantee is a Uniplaces service that provides Accommodation Providers with financial security and peace of mind, offering a safety net in the following situations:' })}
      </p>
      <ul>
        <li>
          {intl.formatMessage({ id: 'Early Departure, when Users unexpectedly vacate the property before the term of the tenancy agreement.' })}
        </li>
      </ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 12/1' }))}
      <ul>
        <li>{intl.formatMessage({ id: 'acts of God, flood, drought, earthquake or other natural disaster;' })}</li>
        <li>{intl.formatMessage({ id: 'epidemic or pandemic;' })}</li>
        <li>{intl.formatMessage({ id: 'terrorist attack, civil war, civil commotion or riots, war, threat of or preparation for war or armed conflict;' })}</li>
        <li>{intl.formatMessage({ id: 'collapse of buildings, fire, explosion or accident; and' })}</li>
        <li>{intl.formatMessage({ id: 'interruption or failure of utility service.' })}</li>
      </ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 12/2' }))}
      <h3>{intl.formatMessage({ id: '13. Uniplaces’ Selection Programme' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 13' }))}
      <h3>{intl.formatMessage({ id: '14. Your Conduct' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 14' }))}
      <h3>{intl.formatMessage({ id: '15. Uniplaces’ Rights' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 15' }))}
      <h3>{intl.formatMessage({ id: '16. Intellectual Property' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 16' }))}
      <h3>{intl.formatMessage({ id: '17. Security' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 17' }))}
      <h3>{intl.formatMessage({ id: '18. Electronic Communications' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 18' }))}
      <h3>{intl.formatMessage({ id: '19. Privacy' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 19' }))}
      <h3>{intl.formatMessage({ id: '20. Use of Information Submitted' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 20' }))}
      <h3>{intl.formatMessage({ id: '21. No Warranty & Liability Limit' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 21' }))}
      <h3>{intl.formatMessage({ id: '22. Indemnity' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 22' }))}
      <h3>{intl.formatMessage({ id: '23. Disputes' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 23' }))}
      <h3>{intl.formatMessage({ id: '24. Termination' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 24' }))}
      <h3>{intl.formatMessage({ id: '25. Membership of the Property Redress Scheme' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 25' }))}
      <h3>{intl.formatMessage({ id: '26. General' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 26' }))}
      <h3>{intl.formatMessage({ id: '27. Contact Us' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Terms of Service 27' }))}
      <h3>{intl.formatMessage({ id: 'Schedule' })}</h3>
      <h5>{intl.formatMessage({ id: 'Model cancellation form' })}</h5>
      <p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'Model cancellation address' }) }} />
      <p dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'Model cancellation example' }) }} />
    </div>
  );
}

export default TermsOfServiceTab;
